module.exports = __webpack_public_path__ + "static/media/bg-banner-health-plans.946f52ab.jpg";